export default __webpack_public_path__ + "static/media/userA.aaccd713.svg";